import { FIELD_TYPES } from "../constants";

export const HEADERS = (visit) => ({
  visitCategory: "Visit Category",
  visitName: "Visit Name",
  visitStudyDay: `Visit Study ${visit.visitIntervalType}`,
  visitVarianceType: "(+/-)",
  visitVariance: `Visit Window ${visit.visitWindowIntervalType}`,
  // visitCostTotal: "Total Visit Cost",
  miEstSDRSDV: "100% SDR/SDV Time (mins)",
  miSampleVisit: "CRA Sampled Visit",
  miSuggestedOnSiteSDRSDV: "Onsite SDR/SDV (mins)",
  miSuggestedCDAReview: "CDA Review (mins)",
  dmUniqueCRFs: "Unique CRFs",
  dmNonUniqueCRFs: "Non-unique CRFs",
  // dmIntegratedEpro: "Integrated ePRO",
  // dmPaperEpro: "Paper PRO",
  // dmCentralLab: "Central Lab",
  // dmLocalLab: "Local Lab",
  commentsVisit: "Visit Comments",
  commentsCost: "Cost Comments",
  commentsClinicalStrategy: "Clinical Strategy Comments",
  commentsDataManagement: "Data Management Comments",
});

export const COUNTRY_HEADERS = (visit, SOECountries) => [
  "Visit Category",
  "Visit Name",
  `Visit Study ${visit.visitIntervalType}`,
  "(+/-)",
  `Visit Window ${visit.visitWindowIntervalType}`,
  ...SOECountries.filter((soc) => soc.siteGroupId).map(
    (soc) => `${soc.siteGroupName} - ${soc.dropDownListLabel} - Total Visit Cost`
  ),
];

export const getCommentType = (fieldType, tableType = "visit") => {
  if (fieldType === FIELD_TYPES.VISIT) 
    return tableType === "assessment" ? "Assessment Comments" : "Visit Comments";
  if (fieldType === FIELD_TYPES.COST) return "Cost Comments";
  if (fieldType === FIELD_TYPES.MEDICAL) return "Clinical Strategy Comments";
  if (fieldType === FIELD_TYPES.DATA_MANAGEMENT) return "Data Management Comments";
  return "";
};

export const getCommentWidth = (commentType, readOnly) => {
  let width = 0;
  switch (commentType) {
    case "Visit Comments":
    case "Assessment Comments":
      width = 50;
      break;
    case "Cost Comments":
      width = 38;
      break;
    case "Clinical Strategy Comments":
      width = 26;
      break;
    case "Data Management Comments":
      width = 38;
      break;
    default:
      return "0%";
  }
  return `${readOnly ? width + 2 : width}%`;
};
